import { checkAuthCookie } from '@helpers';
import { AuthRequest, AuthService, IAccessToken, IUserAuth } from '@utils';
import { addMonths } from 'date-fns';
import jwt_decode from 'jwt-decode';
import { action, makeObservable, observable } from 'mobx';
import 'reflect-metadata';
import { Inject, Service } from 'typedi';
import { PushStore } from '../../store';

@Service()
export class LoginViewModel {

  @Inject(() => AuthRequest)
  private authRequest: AuthRequest;

  /**
   * @param authorized - буленовское значение, отвечающее за авторизацию пользователя
   */
  @observable authorized = checkAuthCookie();

  @observable firstAuthorization = false;

  @observable.ref user: IUserAuth = null;

  constructor() {
    makeObservable(this);
  }

  /** экшен обновления статуса авторизации */
  @action updateAuth = () => {
    this.authorized = checkAuthCookie();
  };

  @action setUser = () => {
    const userId = AuthService.getUserIdFromCookie();
    this.authRequest.setUser(userId).then((response) => {
      this.user = response.data;
    });
  };

  @action signIn = (login: string, password: string) => (
    this.authRequest.authorize(login, password)
      .then(
        (response) => {
          const accessToken = jwt_decode(response.data.accessToken) as IAccessToken;

          const date: Date = new Date(accessToken.exp * 1000);
          const refreshDate: Date = addMonths(date, 2);
          if (response.data.accessToken) {
            AuthService.setCookies(response.data.accessToken, response.data.refreshToken);
          }
          this.firstAuthorization = response.data.firstAuthorization;
          if (this.authorized) {
            /** здесь мы установим в куки и стор текущего пользователя, когда на беке появится функция получения пользователей */
            // this.setUser();
          }
          return response.data;
        },
      )
      .then(() => this.updateAuth())
      .catch(() => {
        return null;
      })
  );


  /** экшен выхода из аккаунта */
  @action logout = () => {
    this.authRequest.logout().then(AuthService.logout);
    this.authorized = false;
    localStorage.clear();
    sessionStorage.clear();
  };
}
